import { createSlice } from "@reduxjs/toolkit";

const passbookSlice = createSlice({
  name: "passbook",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {
    getPassbookDataRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getPassbookDataSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload.data || null;
    },
    getPassbookDataFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getPassbookDataRequest,
  getPassbookDataSuccess,
  getPassbookDataFailure,

} = passbookSlice.actions;

export default passbookSlice.reducer;
